"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Editor = require("tui-editor");
// tui editor extensions
require("tui-editor/dist/tui-editor-extTable.js");
require("tui-editor/dist/tui-editor-extColorSyntax.js");
require("tui-editor/dist/tui-editor-extScrollSync.js");
// tui editor styles
require("codemirror/lib/codemirror.css"); // codemirror
require("tui-editor/dist/tui-editor.css"); // editor ui
require("tui-editor/dist/tui-editor-contents.css"); // editor content
require("highlight.js/styles/github.css"); // code block highlight
var TuiEditor = /** @class */ (function (_super) {
    __extends(TuiEditor, _super);
    function TuiEditor() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.setWrapper = function (node) { return (_this.wrapper = node); };
        _this.onChange = function () { return (_this.props.onChange ? _this.props.onChange(_this.editor) : null); };
        _this.onLoad = function () { return (_this.props.onLoad ? _this.props.onLoad(_this.editor) : null); };
        _this.onStateChange = function () {
            return _this.props.onStateChange ? _this.props.onStateChange(_this.editor) : null;
        };
        _this.onFocus = function () { return (_this.props.onFocus ? _this.props.onFocus(_this.editor) : null); };
        _this.onBlur = function () { return (_this.props.onBlur ? _this.props.onBlur(_this.editor) : null); };
        _this.addImageBlobHook = function (data, callback, source) { return __awaiter(_this, void 0, void 0, function () {
            var url;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.props.fileUploadHandler) {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.props.fileUploadHandler(data, source)];
                    case 1:
                        url = _a.sent();
                        callback(url);
                        return [2 /*return*/];
                }
            });
        }); };
        return _this;
    }
    TuiEditor.prototype.componentDidMount = function () {
        if (this.wrapper) {
            var _a = this.props, initialEditType = _a.editType, previewStyle = _a.previewStyle, height = _a.height, minHeight = _a.minHeight, setEditor = _a.setEditor, initialValue = _a.value, exts = _a.exts, _b = _a.toolbarItems, toolbarItems = _b === void 0 ? [
                'heading',
                'bold',
                'italic',
                'strike',
                'divider',
                'hr',
                'quote',
                'divider',
                'ul',
                'ol',
                'task',
                'indent',
                'outdent',
                'divider',
                'table',
                'image',
                'link',
                'divider',
                'code',
                'codeblock',
            ] : _b;
            this.editor = new Editor({
                el: this.wrapper,
                initialEditType: initialEditType,
                previewStyle: previewStyle,
                height: height,
                minHeight: minHeight,
                initialValue: initialValue,
                exts: exts,
                events: {
                    change: this.onChange,
                    load: this.onLoad,
                    stateChange: this.onStateChange,
                    focus: this.onFocus,
                    blur: this.onBlur,
                },
                hooks: {
                    addImageBlobHook: this.addImageBlobHook,
                },
                toolbarItems: toolbarItems,
            });
            if (setEditor) {
                setEditor(this.editor);
            }
        }
    };
    TuiEditor.prototype.componentDidUpdate = function (prevProps) {
        if (!this.editor) {
            return;
        }
        var _a = this.props, editType = _a.editType, previewStyle = _a.previewStyle, height = _a.height, minHeight = _a.minHeight, value = _a.value;
        if (previewStyle && previewStyle !== prevProps.previewStyle) {
            this.editor.changePreviewStyle(previewStyle);
        }
        if (height && height !== prevProps.height) {
            this.editor.height(height);
        }
        if (minHeight && minHeight !== prevProps.minHeight) {
            this.editor.minHeight(minHeight);
        }
        if (value && value !== this.editor.getMarkdown()) {
            this.editor.setMarkdown(value);
        }
        if (editType && editType !== prevProps.editType) {
            this.editor.changeMode(editType, false);
        }
    };
    TuiEditor.prototype.componentWillUnmount = function () {
        if (this.editor) {
            this.editor.remove();
        }
    };
    TuiEditor.prototype.render = function () {
        return React.createElement("div", { ref: this.setWrapper });
    };
    return TuiEditor;
}(React.Component));
exports.default = TuiEditor;
